import { APP_NAME, APPID } from '@/const';
import UserTrack from '@relx/user-track';
import { v4 as uuidV4 } from 'uuid';
import Cookie from 'js-cookie';

export const getDeviceId = () => {
  // 本地缓存
  const deviceId = window.localStorage.getItem('DEVICE_ID_STORE');
  if (deviceId) {
    return deviceId;
  }

  let userData: { first_id: string; distinct_id: string } = {
    first_id: '',
    distinct_id: '',
  };

  try {
    userData = JSON.parse(
      decodeURIComponent(Cookie.get('sensorsdata2015jssdkcross') || ''),
    );
  } catch (error) {}

  let distinctId = userData.first_id ? userData.first_id : userData.distinct_id;

  if (!distinctId) {
    distinctId = uuidV4();
  }

  window.localStorage.setItem('DEVICE_ID_STORE', distinctId);
  return distinctId;
};

const getUserId = () => {
  try {
    const userId = Cookie.get('accountId');
    return userId;
  } catch (err) {}
};

const commonProperties: any = {
  app_id: APPID,
  app_name: APP_NAME,
  device_id: getDeviceId(),
  user_id: getUserId(),
};

export const userTrack = UserTrack.getInstance(
  window.location.hostname === 'store.relxtech.com' ? 'prd' : 'beta',
);

const registerGlobalError = () => {
  // 代码异常
  window.onerror = function(msg, url, row, col, error) {
    try {
      userTrack.log('app_system_error', {
        error_type: 'onerror',
        error_info: {
          msg,
          url,
          row,
          col,
          stack: error?.stack?.toString(),
        },
      });
    } catch (e) {}
  };

  // 捕获资源请求失败
  window.addEventListener(
    'error',
    function(e) {
      try {
        const el = e.target;
        if (el instanceof HTMLElement) {
          userTrack.log('app_system_error', {
            error_type: 'error',
            error_info: {
              tagName: el.tagName,
              src: (el as any).src || (el as any).href,
            },
          });
        }
      } catch (e) {}
    },
    true,
  );

  // 捕获Promise未catch错误
  window.addEventListener('unhandledrejection', function(e) {
    try {
      userTrack.log('app_system_error', {
        error_type: 'unhandledrejection',
        error_info: {
          reason: e.reason,
        },
      });
    } catch (error) {}
  });
};

export const initUserTrack = () => {
  try {
    userTrack.registerCommonProperties(commonProperties);
    userTrack.log('app_system_load');
    registerGlobalError();
  } catch (error) {}
};
